import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

interface PasswordRequirements {
  minLength: boolean;
  upperCase: boolean;
  number: boolean;
  specialChar: boolean;
}

@Component({
  selector: 'kt-password-requirements',
  templateUrl: './password-requirements.component.html',
  styleUrls: ['./password-requirements.component.scss']
})
export class PasswordRequirementsComponent implements OnChanges {
  @Input() password: string = '';

  requirements: PasswordRequirements = {
    minLength: false,
    upperCase: false,
    number: false,
    specialChar: false
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['password']) {
      const val = this.password || '';
      this.requirements = {
        minLength: val.length >= 8,
        upperCase: /[A-Z]/.test(val),
        number: /[0-9]/.test(val),
        specialChar: /[^a-zA-Z0-9]/.test(val)
      };
    }
  }
}
